<template>
  <router-view></router-view>
</template>

<script>
export default {
  name: "AdminPanel"
};
</script>

<style>
</style>



// WEBPACK FOOTER //
// src/components/gt/admin/AdminPanel.vue